/**
 * TestRepositoryPage - Test Repository with Modern Layout
 *
 * Same layout as Heat Profile and DCAL Generator: title, description, Back To Technical,
 * tabs (Heat Profile, Test Repository, DCAL Generator), then Test Repository list card and table.
 * Uses ModernLayout. Table structure and styling match Heat Profile / DCAL Generator.
 */

import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ChevronLeft, Flame, FileText, Wrench } from 'lucide-react';
import TechnicalPageAgGrid from '../../components/CRCE Technical/TechnicalPageAgGrid';
import './HeatProfilePage.css';
import './TestRepositoryPage.css';

const TECHNICAL_TAB_ITEMS = [
    { id: 'heat-profile', label: 'Heat Profile', path: '/heat-profile', icon: <Flame size={18} /> },
    { id: 'test-repository', label: 'Test Repository', path: '/TechnicalPage', icon: <FileText size={18} /> },
    { id: 'dcal-generator', label: 'DCAL Generator', path: '/DCALGenerator', icon: <Wrench size={18} /> },
];

const TestRepositoryPage = () => {
    const history = useHistory();
    const location = useLocation();
    const currentPath = location.pathname;

    const handleBackClick = () => {
        if (window.history.length > 1) {
            history.goBack();
        } else {
            history.push('/technical');
        }
    };

    const handleTabClick = (path) => {
        if (path !== currentPath) {
            history.push(path);
        }
    };

    return (
        <div className="test-repository-page">
            <div className="test-repository-page-top-section">
                <div className="test-repository-page-heading">
                    <h1 className="test-repository-page-title">Test Repository</h1>
                    <p className="test-repository-page-description">
                        Browse and manage coating technical test reports and data.
                    </p>
                    <a
                        href="#back"
                        onClick={(e) => {
                            e.preventDefault();
                            handleBackClick();
                        }}
                        className="test-repository-page-back-link"
                    >
                        <div className="test-repository-back-link">
                            <ChevronLeft size={16} /> Back To Technical
                        </div>
                    </a>
                </div>
            </div>

            <div className="test-repository-tabs-container">
                <div className="test-repository-tabs">
                    {TECHNICAL_TAB_ITEMS.map((item) => (
                        <div
                            key={item.id}
                            className={`test-repository-tab-item ${currentPath === item.path ? 'active' : ''}`}
                            onClick={() => handleTabClick(item.path)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    handleTabClick(item.path);
                                }
                            }}
                            role="tab"
                            tabIndex={0}
                            aria-selected={currentPath === item.path}
                        >
                            {item.icon}
                            {item.label}
                        </div>
                    ))}
                </div>
            </div>

            <div className="test-repository-divider" />

            <div className="test-repository-content-wrapper heat-profile-content-wrapper">
                <TechnicalPageAgGrid embeddedInModernLayout />
            </div>
        </div>
    );
};

export default TestRepositoryPage;
